import { Injectable, inject } from '@angular/core';

import { OnAppInit } from '@frontend/vanilla/core';
import { firstValueFrom } from 'rxjs';

import { LoaderService } from './loader.service';
import { LoadersConfig } from './loaders.client-config';

@Injectable()
export class LoadersBootstrapService implements OnAppInit {
    private config = inject(LoadersConfig);
    private loaderService = inject(LoaderService);

    async onAppInit() {
        await firstValueFrom(this.config.whenReady);
        this.loaderService.init();
    }
}
